var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E19100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_6975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4 10.75C9.95825 10.75 9.6 11.1418 9.6 11.625V13.375C9.6 13.859 9.24175 14.25 8.8 14.25C8.35825 14.25 8 13.859 8 13.375V11.625C8 10.1752 9.0745 9 10.4 9H21.6C22.925 9 24 10.1752 24 11.625V13.375C24 13.859 23.6425 14.25 23.2 14.25C22.7575 14.25 22.4 13.859 22.4 13.375V11.625C22.4 11.1418 22.0425 10.75 21.6 10.75H10.4Z",
    fill: "#BE7A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.2 23H12.8C11.9175 23 11.2 22.2152 11.2 21.25V11.625H20.8V21.25C20.8 22.2152 20.0825 23 19.2 23ZM13.6 16.4375C13.6 17.6461 14.6525 18.625 16 18.625C17.325 18.625 18.4 17.6461 18.4 16.4375C18.4 15.2289 17.325 14.25 16 14.25C14.6525 14.25 13.6 15.2289 13.6 16.4375Z",
    fill: "#BE7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_6975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.d2039672f491dffcdf8b179904dd5b7f.svg";
export { ForwardRef as ReactComponent };